import React from 'react'

const ThumbDownOutlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.9993 17.5002H4.83268V6.66683L10.666 0.833496L11.7077 1.87516C11.8049 1.97238 11.8848 2.10433 11.9473 2.271C12.0098 2.43766 12.041 2.59738 12.041 2.75016V3.04183L11.1243 6.66683H16.4993C16.9438 6.66683 17.3327 6.8335 17.666 7.16683C17.9993 7.50016 18.166 7.88905 18.166 8.3335V10.0002C18.166 10.0974 18.1521 10.2016 18.1243 10.3127C18.0966 10.4238 18.0688 10.5279 18.041 10.6252L15.541 16.5002C15.416 16.7779 15.2077 17.0141 14.916 17.2085C14.6243 17.4029 14.3188 17.5002 13.9993 17.5002ZM6.49935 15.8335H13.9993L16.4993 10.0002V8.3335H8.99935L10.1243 3.75016L6.49935 7.37516V15.8335ZM4.83268 6.66683V8.3335H2.33268V15.8335H4.83268V17.5002H0.666016V6.66683H4.83268Z'
      fill='currentColor'
    />
  </svg>
)

export default ThumbDownOutlineIcon
